import { BlockTypes } from "../models/BlockTransportSystemJsonModel";
import { CNSSetLayoutStyles } from "../models/CNSSetLayoutStyles";
import { TextAlignTypes } from "../models/TextAlignTypes";
import { PolarProductTypes } from "./PolarProductTypes";
import { PresetGroups } from "./PresetConfig";

export enum BlockPresetTypes {
    Custom = "Custom",
    IpSpecialPola = "IpSpecialPola",
    IpSpecialColornames = "IpSpecialColornames",
    PromotionPhotocard = "PromotionPhotocard",
    PromotionCardcovers = "PromotionCardcovers",
    CheerUpGroupSlogan = "CheerUpGroupSlogan",
    CheerUpMemberSlogan = "CheerUpMemberSlogan",
    IpSpecialCheerUp = "IpSpecialCheerUp",
    CheerUpCustomSlogan = "CheerUpCustomSlogan",
    Colornames = "Colornames",
    LargeNames = "LargeNames",
    NemoNames = "NemoNames"
}

export interface BlockPresetConfig {
    groups: PresetGroups[];
    presetType: BlockPresetTypes;
    blockType: BlockTypes;
    colorNamesLayout: CNSSetLayoutStyles;
    defaultTextAlignType?: TextAlignTypes;
    dedicatedProducts: PolarProductTypes[];
    isTextAlignTypeConfigurable?: boolean;
    isDedicatedProductsConfigurable?: boolean;
    isMediaSizeConfigurable?: boolean;
    isBlockTypeConfigurable?: boolean;
    isLayoutTypeConfigurable?: boolean;
    isPriorityConfigurable?: boolean;
    isActivationDateConfigurable?: boolean;
    isCutImageConfigurable?: boolean;
    isPhotoCardImagesConfigurable?: boolean;
    isPhotoCardSilverImagesConfigurable?: boolean;
    isIconImageConfigurable?: boolean;
    isPrevewImageConfigurable?: boolean;
}

export const blockPresetConfigs: BlockPresetConfig[] = [
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.Custom,
        blockType: BlockTypes.none,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [],
        isTextAlignTypeConfigurable: true,
        isDedicatedProductsConfigurable: true,
        isMediaSizeConfigurable: true,
        isBlockTypeConfigurable: true,
        isLayoutTypeConfigurable: true,
        isActivationDateConfigurable: true,
        isCutImageConfigurable: true,
        isPhotoCardImagesConfigurable: true,
        isPhotoCardSilverImagesConfigurable: true,
        isIconImageConfigurable: true,
        isPrevewImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Anipuri],
        presetType: BlockPresetTypes.IpSpecialPola,
        blockType: BlockTypes.ipSpecial,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.IpSpecial],
        isPrevewImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Anipuri],
        presetType: BlockPresetTypes.PromotionPhotocard,
        blockType: BlockTypes.photoCard,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.PhotoCard],
        isPhotoCardImagesConfigurable: true,
        isPhotoCardSilverImagesConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.IpSpecialPola,
        blockType: BlockTypes.ipSpecial,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.IpSpecial],
        isPriorityConfigurable: true,
        isPrevewImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.IpSpecialColornames,
        blockType: BlockTypes.colorNames,
        colorNamesLayout: CNSSetLayoutStyles.LEFT,
        dedicatedProducts: [PolarProductTypes.IpSecialColornames],
        isPriorityConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.PromotionPhotocard,
        blockType: BlockTypes.photoCard,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.PhotoCard],
        isLayoutTypeConfigurable: true,
        isPriorityConfigurable: true,
        isPhotoCardImagesConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.PromotionCardcovers,
        blockType: BlockTypes.cardCoverStickerDieCut,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.CardCoverStickerDieCut],
        isPriorityConfigurable: true,
        isPrevewImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.CheerUpGroupSlogan,
        blockType: BlockTypes.cheerUpSlogan,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.CheerUpGroupSlogan],
        isMediaSizeConfigurable: true,
        isPriorityConfigurable: true,
        isActivationDateConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.CheerUpMemberSlogan,
        blockType: BlockTypes.cheerUpSlogan,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.CheerUpMemberSlogan],
        isMediaSizeConfigurable: true,
        isPriorityConfigurable: true,
        isActivationDateConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.IpSpecialCheerUp,
        blockType: BlockTypes.cheerUpSlogan,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.IpSpecialCheerUp],
        isMediaSizeConfigurable: true,
        isPriorityConfigurable: true,
        isActivationDateConfigurable: true,
    },
    {
        groups: [PresetGroups.Poluv],
        presetType: BlockPresetTypes.CheerUpCustomSlogan,
        blockType: BlockTypes.cheerUpSlogan,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.CheerUpCustomSlogan],
        isMediaSizeConfigurable: true,
        isPriorityConfigurable: true,
        isActivationDateConfigurable: true,
        isPrevewImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Moshi],
        presetType: BlockPresetTypes.IpSpecialColornames,
        blockType: BlockTypes.colorNames,
        colorNamesLayout: CNSSetLayoutStyles.LEFT,
        dedicatedProducts: [PolarProductTypes.IpSecialColornames],
        isPriorityConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Moshi],
        presetType: BlockPresetTypes.Colornames,
        blockType: BlockTypes.colorNames,
        colorNamesLayout: CNSSetLayoutStyles.CHARACTER,
        dedicatedProducts: [PolarProductTypes.ColornamesColorful],
        isActivationDateConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Moshi],
        presetType: BlockPresetTypes.LargeNames,
        blockType: BlockTypes.graphicNames,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        defaultTextAlignType: TextAlignTypes.innerAlign,
        dedicatedProducts: [PolarProductTypes.GraphicNamesticker],
        isTextAlignTypeConfigurable: true,
        isActivationDateConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true,
    },
    {
        groups: [PresetGroups.Moshi],
        presetType: BlockPresetTypes.NemoNames,
        blockType: BlockTypes.graphicNames12cut,
        colorNamesLayout: CNSSetLayoutStyles.NONE,
        dedicatedProducts: [PolarProductTypes.GraphicNamesticker12cut],
        isActivationDateConfigurable: true,
        isPrevewImageConfigurable: true,
        isIconImageConfigurable: true,
    },
]
